export interface RemoteConfigAppResponse {
  isApplicationBetaVersionAvailable?: boolean;
  serviceAppAvailable?: boolean;
  createNewInvitationAvailable?: boolean;
  commissioningAvailable?: boolean;
  monetizationAvailable?: boolean;
  floorHeatingThermostatAvailable?: boolean;
  gatewayCommissioningAvailable?: boolean;
  isLearningRoomBannerAvailable?: boolean;
  isViessmannEventBannerAvailable?: boolean;
  areProPlusFeaturesForVkOrgAvailable?: boolean;
  areProPlusFeaturesForCompanyIdAvailable?: boolean;
  isNewVitoguideFeaturesBannerAvailable?: boolean;
  isPodcastBannerVisible?: boolean;
  isPaidFeaturesBannerAvailable?: boolean;
  bookingProButtonEnabled?: boolean;
  bookingPlusButtonEnabled?: boolean;
  flatRateVkorg?: boolean;
  isE3HeatPumpMarketLaunchBannerVisible?: boolean;
  isViguideRenameBannerAvailable?: boolean;
  isFirmwareUpdateAvailable?: boolean;
  spaceClimateCoolingAvailable?: boolean;
  appInsightsUserLogLevel?: number;
  isHardwareBundlingAvailable?: boolean;
  azureCertificateFirmwareCheck?: boolean;
  isVicarePlansTileAvailable?: boolean;
  isEcotronicAvailable?: boolean;
  shouldFetchEnergyConsumptionDataForLegacyHeatpump?: boolean;
  isSmartHomeComponentsUsingMock?: boolean;
  isSmartHomeComponentsAvailable?: boolean;
  isNotAbleToHandleAllRequestsRegardingHeatpumpsAndVentilationSystemsBannerVisible?: boolean;
  restrictedAccessForTestAutomationInstallationsEnabled?: boolean;
  isRoadshowBannerVisible?: boolean;
  countriesWithSmartHomeComponent?: string;
  isVitoconnectIssueOccurs?: boolean;
  isAppInsightsLoggingDataAboutDhw?: boolean;
  isBoilerSerialEditable?: boolean;
  isCanadaAndUSABookingAvailable?: boolean;
  callbackMondayHours?: string;
  callbackTuesdayHours?: string;
  callbackWednesdayHours?: string;
  callbackThursdayHours?: string;
  callbackFridayHours?: string;
  callbackSaturdayHours?: string;
  callbackSundayHours?: string;
  isAdvertisingBannerForDeAndAuVisible?: boolean;
  isBannerForEkUserVisible?: boolean;
  blockEndCustomers?: boolean;
  isFirmwareUpdateAvailableHours?: string;
  isFirmwareUpdateAvailableWeekdays?: string;
  serviceTicketVkorgList?: string; // values separated with comma like "a,b,c"
  serviceTicketCallNowBlacklist?: string; // values separated with comma like "a,b,c"
  serviceTicketAllowedByCompanyId?: boolean;
  showGenericInfoBanner?: boolean;
  xOTAFirmwareVersionBlackList?: string; // values separated with comma like "a,b,c"
  isSurveyBannerVisible?: boolean;
  domainSwitchInformationBannerVisible?: boolean;
  switchToClimateSolutionsDomain?: boolean;
  powerLimitationsEventLogVisible?: string; // values separated with comma like "a,b,c"
  rsaViUnifyAccessIds?: string; // values separated with comma like "a,b,c"
  heatingSystemsAccess?: string;
  isHeatingSystemsLinkVisibleInSideMenu?: boolean;
  isWhatsAppBannerVisible?: boolean;
}

export enum RemoteConfigBanners {
  RoadShow = 'isRoadshowBannerVisible',
  Testieger = 'isTestiegerBannerVisible',
  vitoconnectIssueBanner = 'isVitoconnectIssueOccurs',
  isNotAbleToHandleAllRequestsBannerVisible = 'isNotAbleToHandleAllRequestsRegardingHeatpumpsAndVentilationSystemsBannerVisible',
  advertisingBannerForDeAndAu = 'isAdvertisingBannerForDeAndAuVisible',
  isBannerForEkUserVisible = 'isBannerForEkUserVisible',
}

export interface RemoteConfigResponse {
  links: any[];
  version: string;
  startedAt: string;
  properties: {
    description: string;
    href: string;
    method: string;
    name: string;
    params: {
      name: string;
      type: string;
    };
    payload: {
      name: string;
      type: string;
      children?: {
        name: string;
        type: string;
      };
    }[];
    query: any[];
  };
}
